import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';

/** 표 4개 세로 배치, 좁은 화면에선 묶음 전체를 가로 스크롤 */
export const SaTravelExpenseRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': {
    ...approvalFormTableStyles(theme),
    margin: 0,
  },
  '& .text-center, & .text-center td': {
    textAlign: 'center',
  },
  '& a': {
    display: 'inline-flex',
    alignItems: 'center',
    color: 'var(--dk-text, #1A1A1A)',
  },
}));

/** 179 — 레거시 마크업(class 동일)에 쓰인 유틸 class 만 보충, 좁은 화면에선 묶음 전체를 가로 스크롤 */
export const SaTravelRequestRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  fontSize: 14,
  lineHeight: '22px',
  color: 'var(--dk-text, #1A1A1A)',
  '& table': {
    ...approvalFormTableStyles(theme),
    margin: '4px 0 8px',
  },
  '& .text-center, & .text-center td': { textAlign: 'center' },
  '& .text-left, & .text-center td.text-left': { textAlign: 'left' },
  '& .d-block': { display: 'block' },
  '& .d-flex': { display: 'flex' },
  // 레거시 ⌜주⌟ 칸(인라인 min-width 는 조회 변환에서 빠짐)
  '& .d-flex > div:first-of-type': { minWidth: 34 },
  '& .p-30': { padding: '24px 0' },
  '& .mb-20': { marginBottom: 20 },
  '& .pt-10': { paddingTop: 10 },
  '& .mt-20': { marginTop: 20 },
  '& .mt-40': { marginTop: 40 },
  '& .pb-10': { paddingBottom: 10 },
  '& .pb-20': { paddingBottom: 20 },
  '& .mb-40': { marginBottom: 40 },
  '& .ml-5': { marginLeft: 5 },
  '& .ml-20': { marginLeft: 20 },
  '& .mt-5': { marginTop: 5 },
  '& strong': { fontWeight: 600, marginBottom: 8 },
  '& ul': { margin: 0, padding: 0, listStyle: 'none' },
  '& p': { margin: 0 },
  '& tfoot td': { fontWeight: 600 },
  '& a': {
    display: 'inline-flex',
    alignItems: 'center',
    color: 'var(--dk-text, #1A1A1A)',
  },
}));
